import { useEffect, useState } from "react";
import { api, API_BASE } from "./api";
import { CASES } from "../data/site";

let cache = null;

export const useCases = () => {
  const [cases, setCases] = useState(cache || CASES);
  const [loaded, setLoaded] = useState(!!cache || !API_BASE);

  useEffect(() => {
    if (cache || !API_BASE) return undefined;
    let alive = true;
    api.get("/case-studies")
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length) cache = r.data;
        if (alive && cache) setCases(cache);
      })
      .catch(() => {})
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, []);

  return { cases, loaded };
};

export const clearCasesCache = () => { cache = null; };
